import React from 'react'
import { PCCCategories } from '_constants'
import { PatientCategoryTab } from 'PatientCareCenter/Home'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';

class PatientCategoryList extends React.Component {

    render() {
        const list = PCCCategories.map((category) => {
            return (
                <PatientCategoryTab
                    key={category.id}
                    categoryId={category.id}
                    name={category.name}
                    ptno={this.props.ptno}
                    changeCategory={this.props.changeCategory}
                    selected={this.props.selectedHomeCategory === category.id ? true : false} />
            );
        });

        return (
            <div>
                {list}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeCategory: bindActionCreators(patientActions.categoryChange, dispatch)
    };
}

function mapStateToProps(state) {
    return {
        selectedHomeCategory: state.ui.patientCenter[state.ui.patients.selectedPtno].selectedHomeCategory,
        ptno: state.ui.patients.selectedPtno
    };
}

const connectedPatientCategoryList = connect(mapStateToProps, mapDispatchToProps)(PatientCategoryList);
export { connectedPatientCategoryList as PatientCategoryList };
